import React, { ReactNode } from 'react';
import { Span} from "../../components/Header/styles";
import { Button } from "../../common/Button";
import './HeroWithVideo.css';

interface HeroWithVideoProps {
  header: ReactNode;
  title: string;
  text: string;
  videoSrc: string;
}

const HeroWithVideo: React.FC<HeroWithVideoProps> = ({ header, title, text, videoSrc }) => {
  return (
    <div className="hero-container" id="intro">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-header">{header}</div>
        <div className="hero-text-content">
          <h1 className="hero-title">{title}</h1>
          <p className="hero-text">{text}</p>
          
            <Button onClick={()=>{window.location.href = "https://intelic.ddns.me/citasv4?ID=001ALLPMA5244"}}>{("Reservar")}</Button>
          
        </div>
      </div>
    </div>
  );
};

export default HeroWithVideo;

